import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setMachineID } from "../../Landing/Actions";
import * as Actions from '../Actions/index';

const mapStatetoProps = state => {

    const { landing,operations } = state;
    return {
        ...landing, ...operations
    }

};

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators({
        setMachineID:setMachineID,
        getInventoryData:Actions.getInventoryData,
        addDishToReplenish:Actions.addDishToReplenish,
        removeDishToReplenish:Actions.removeDishToReplenish,
        updateDishToReplenish:Actions.updateDishToReplenish,
        setReplenishPlan:Actions.setReplenishPlan,
        clearData:Actions.clearData
    },
    dispatch
    )
});

export default connect(mapStatetoProps,mapDispatchToProps);